<template>
  <el-dialog :close-on-press-escape="closeOnPressEscape" :title="$lang(title)" ref="dialog" class="mw-dialog" :modal="modal"
             :class="[{'mw-dialog__large_large':(size=='large_large')
             ,'mw-dialog__large_small':(size=='large_small')
             ,'mw-dialog__large_mini':(size=='large_mini')
             ,'mw-dialog__small_large':(size=='small_large')
             ,'mw-dialog__small_small':(size=='small_small')
             ,'mw-dialog__small_mini':(size=='small_mini')
             ,'mw-dialog__mini_large':(size=='mini_large')
             ,'mw-dialog__mini_small':(size=='mini_small')
             ,'mw-dialog__mini_mini':(size=='mini_mini')
             ,'mw-dialog__large':(size=='large')
             ,'mw-dialog__small':(size=='small')
             ,'mw-dialog__form':(size=='form')
             ,'mw-dialog__view':(size=='view')
             ,'mw-dialog__page':(size=='page')
             ,'mw-dialog__full':(size=='full')
             ,'mw-dialog__mini':(size=='mini'),'mw-dialog__noFooterButton':(footerButton.length==0) },customClass]"
             @opened="dialogOpen"
             :visible.sync="visible" :close-on-click-modal="closeOnClickModal"  :append-to-body="appendToBody" :before-close="_beforeClose">
    <slot></slot>
    <template slot="footer">
      <template v-if="footerButton.length>0" v-for="item in footerButton">
        <el-button size="mini" :loading="item.loading" :type="item.type?((item.type=='default')?'':item.type):'primary'" v-html="item.label"
                   @click="invokeButtonMethod(item)"></el-button>
      </template>
      <slot name="footer"></slot>
    </template>
  </el-dialog>
</template>
<script>
  export default
  {
    data(){
      return{
        visible:false,
      }
    },
    name: 'mwDialog',
    beforeDestroy(){
      this.mwRef('dialog').$destroy();
    },
    props: {
      closeOnClickModal:{
        type: Boolean,
        default:false
      },
      closeOnPressEscape:{
        type: Boolean,
        default:false
      },
      size: {
        type: String
      },
      modal:{
        type:Boolean,
        default:true
      },
      title: {
        type: String
      },
      customClass: {
        type: String,
        default:''
      },
      appendToBody:{
        type: Boolean,
        default:true
      },
      validateForm:{
        type: Array,
        default: function () {
          return [];
        }
      },
      beforeClose: Function,
      footerButton: {  //底部按钮
        type: Array,
        default: function () {
          return [];
        }
      },
      width:String, //为了能输入 100%,所以用string
      height:String,
    },
    watch: {
      'size'(val, oldVal) {

      },
      width(){
        this.setWidthHeight();
      },
      height(){
        this.setWidthHeight();
      }
    },
    methods: {
      invokeButtonMethod(btn) {
        let fn=btn.func || btn.handler;
        if (fn) {
          fn.call(this);
        }
      },
      setWidthHeight(){
        let el=$(this.$el).find(".el-dialog");
        if (this.width) {
          el.width(this.width);
        }
        if (this.height) {
          el.height(this.height);
          el.css("margin","0 auto");
          let top=($(window).height()-el.height())/2;
          if(top>0)el.css("top",top);
        }
      },
      _beforeClose: function (done) {
        if(this.beforeClose){
          this.beforeClose(done);
        }else{
          done();
        }
      },

      show: function (callback) {
        this.visible=true;
        this.setWidthHeight();
        if(!this.eventInited){
          this.initEvent()
          this.eventInited=true;
        }
        if(callback){
          this.$nextTick(function () {
            callback();
          })
        }
      },
      initEvent:function(){
        //加上一个iframe,让控件无法遮住对话框
        $(this.$el).prepend($("<iframe width='100%' height='100%''></iframe>").css({
          width: '100%',
          height: '100%',
          border: '0px',
          position: "absolute"
        }));

        if(window.$ && $.fn.draggable){
          var dlg=$(this.$refs.dialog.$refs.dialog);
          let oriTop;
          dlg.draggable({
            handle:".el-dialog__header",
            scroll:false,
            stop: function( event, ui ) {
              let el=ui.helper;
              let marginTop=parseInt(el.css("margin-top"));
              let top=parseInt(el.css("top"));
              if(top<-marginTop){
                el.css("top",(-marginTop)+'px')
              }
            }
          });
          var oldTop,oldLeft;
          dlg.find(".el-dialog__header").dblclick(function(){
              if(dlg.hasClass("is-fullscreen")){
                if(oldTop)dlg.css("top",oldTop);
                if(oldLeft)dlg.css("left",oldLeft);
                dlg.removeClass("is-fullscreen");
              }else{
                oldTop=dlg.css("top");
                oldLeft=dlg.css("left");
                dlg.css({top:"", left: ""});
                dlg.addClass("is-fullscreen");
              }
          });
        }

      },
      hide:function () {
        this.visible=false;
      },
      dialogOpen() {
        this.$emit("opened");
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/common/components/extend/dialog/index.vue